import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {

  transform(value: any[], key: string): any[] {
    if (!value || !key) return value;

    return value.sort((a, b) => a[key] > b[key] ? 1 : -1);
  }
}
